import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IMesureUniteState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const mesureUniteModule: Module<IMesureUniteState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default mesureUniteModule
